<header></header>
<div class="post-login-2">
    <div class="post-login-2-col-1 h-100">
        <left-panel activeTab="12"></left-panel>
    </div>
    <div class="post-login-2-col-2 has-banner">
    </div>
    <div class="post-login-2-col-3 bg-base-100 p-mobile-15 h-100vh">
        <grid-row class="justify-content-center h-100">
            <grid-col col="6" mobile="12">
                <div class="font-400 font-size-24px  color-base-700 mt-30">
                    {{"Claims" | translate }}
                 </div>
                 <div class="font-400 font-size-20px  color-base-700 mt-20">
                    {{"Preparedocuments" | translate }}
                 </div>
                <div class="bg-base-100 box-shadow border border-color-900 br-16 mt-20 p-16" *ngIf="this.ClaimList.length > 0">
                    <grid-row class="col-space-min align-item-center" *ngFor="let C of this.ClaimList">
                        <grid-col col="auto">
                            <!-- <ng-icon iconClass="icon-document bg-nuetral-primary br-12" width="40" height="40"></ng-icon> -->
                            <!-- <ng-icon iconClass="{{C.icons}}" width="40" height="40"></ng-icon> -->
                            <!-- <img [src]="C.icons" alt=""> -->
                            <img [src]="C.icons" alt="" width="25" height="25">
                            <!-- <img src="data:image/png;base64,+{{C.icons}}" alt="profile picture"> -->
                            <!-- <img src="{{C.icons}}" alt="profile picture"> -->



                        </grid-col>
                        <grid-col col="auto">
                            <div class="font-600 font-size-14px color-base-3300">
                                <!-- {{"AccidentReport" | translate}} -->{{C.title}}
                            </div>
                        </grid-col>
                    </grid-row>
                    <!-- <grid-row class="col-space-min align-item-center mt-20">
                        <grid-col col="auto">
                            <ng-icon iconClass="icon-camera bg-nuetral-primary br-12" width="40" height="40"></ng-icon>
                        </grid-col>
                        <grid-col col="auto">
                            <div class="font-600 font-size-14px color-base-3300">
                                {{"PhotographicEvidence" | translate}}
                            </div>
                        </grid-col>
                    </grid-row>
                    <grid-row class="col-space-min align-item-center mt-20">
                        <grid-col col="auto">
                            <ng-icon iconClass="icon-license-card bg-nuetral-primary br-12" width="40" height="40"></ng-icon>
                        </grid-col>
                        <grid-col col="auto">
                            <div class="font-600 font-size-14px color-base-3300">
                                {{"DriversLicense" | translate}}
                            </div>
                        </grid-col>
                    </grid-row>
                    <grid-row class="col-space-min align-item-center mt-20">
                        <grid-col col="auto">
                            <ng-icon iconClass="icon-witness-statements bg-nuetral-primary br-12" width="40" height="40"></ng-icon>
                        </grid-col>
                        <grid-col col="auto">
                            <div class="font-600 font-size-14px color-base-3300">
                                {{"WitnessStatements" | translate}}
                            </div>
                        </grid-col>
                    </grid-row>
                    <grid-row class="col-space-min align-item-center mt-20">
                        <grid-col col="auto">
                            <ng-icon iconClass="icon-ambulance bg-nuetral-primary br-12" width="40" height="40"></ng-icon>
                        </grid-col>
                        <grid-col col="auto">
                            <div class="font-600 font-size-14px color-base-3300">
                                {{"MedicalReports" | translate}}
                            </div>
                        </grid-col>
                    </grid-row> -->
                </div>

                <grid-row class="justify-content-between align-item-center mt-50">
                    <!-- <grid-col col="auto">
                        <div class="mt-15">
                            <button class="btn-back" (click)="back()">
                                <i class="icon-back"></i>
                            </button>
                        </div>
                    </grid-col> -->
                    <grid-col col="12">
                        <button class="btn-dft" (click)="showModal(1)" disabled *ngIf="this.ClaimDet.length == 0">
                            {{ "CALL" | translate }}
                        </button>
                        <button class="btn-dft" (click)="showModal(1)"  *ngIf="this.ClaimDet.length > 0">
                            {{ "CALL" | translate }}
                        </button>
                    </grid-col>
                </grid-row>
            </grid-col>
        </grid-row>
    </div>
</div>


<modal modalID="1" [events]="modalObservable.asObservable()" [backdropDismiss]="false" modalDoneButtonStatus="false"
    [whiteButtonStatus]="true" whiteButtonText="cancel" [hideHeader]="false">
    <div class="font-size-14px color-base-1200 font-400">
        {{"REQUESTCLAIM" | translate}}
    </div>
    <div *ngFor="let item of this.ClaimDet">
        <a href="tel:{{item.contactNumber1}}" class="text-dec-none" *ngIf="item.contactNumber1 != '' " >
            <grid-row class="col-space-min align-item-center border-bottom border-color-2100 mt-30 pb-10">
                <grid-col col="auto">
                    <ng-icon iconClass="icon-phone-call" width="24" height="24"></ng-icon>
                </grid-col>
                <grid-col col="auto">
                    <div class="font-400 font-size-14px color-base-1300">
                        {{"forAssistance" | translate}}
                    </div>
                </grid-col>
            </grid-row>
        </a>
        <a href="tel:{{item.contactNumber2}}" class="text-dec-none" *ngIf="item.contactNumber2 != '' " >
            <grid-row class="col-space-min align-item-center border-bottom border-color-2100 mt-30 pb-10">
                <grid-col col="auto">
                    <ng-icon iconClass="icon-phone-call" width="24" height="24"></ng-icon>
                </grid-col>
                <grid-col col="auto">
                    <div class="font-400 font-size-14px color-base-1300">
                        {{"forAssistance" | translate}}
                    </div>
                </grid-col>
            </grid-row>
        </a>
        
        <a href="tel:{{item.contactNumber3}}" class="text-dec-none" *ngIf="item.contactNumber3 != '' " >
            <grid-row class="col-space-min align-item-center border-bottom border-color-2100 mt-30 pb-10">
                <grid-col col="auto">
                    <ng-icon iconClass="icon-phone-call" width="24" height="24"></ng-icon>
                </grid-col>
                <grid-col col="auto">
                    <div class="font-400 font-size-14px color-base-1300">
                        {{"forAssistance" | translate}}
                    </div>
                </grid-col>
            </grid-row>
        </a>

        <a href="tel:{{item.whatsAppNumber1}}" class="text-dec-none" *ngIf="item.whatsAppNumber1 != '' " >
            <grid-row class="col-space-min align-item-center border-bottom border-color-2100 mt-30 pb-10">
                <grid-col col="auto">
                    <ng-icon iconClass="icon-phone-call" width="24" height="24"></ng-icon>
                </grid-col>
                <grid-col col="auto">
                    <div class="font-400 font-size-14px color-base-1300">
                        {{"forAssistance" | translate}}
                    </div>
                </grid-col>
            </grid-row>
        </a>

        <a href="tel:{{item.whatsAppNumber2}}" class="text-dec-none" *ngIf="item.whatsAppNumber2 != '' " >
            <grid-row class="col-space-min align-item-center border-bottom border-color-2100 mt-30 pb-10">
                <grid-col col="auto">
                    <ng-icon iconClass="icon-phone-call" width="24" height="24"></ng-icon>
                </grid-col>
                <grid-col col="auto">
                    <div class="font-400 font-size-14px color-base-1300">
                        {{"forAssistance" | translate}}
                    </div>
                </grid-col>
            </grid-row>
        </a>


        <a href="mailto:{{item.email}}" target="_blank" class="text-dec-none" *ngIf="item.email != ''" >
            <grid-row class="col-space-min align-item-center border-bottom border-color-2100 mt-30 pb-10">
                <grid-col col="auto">
                    <ng-icon iconClass="icon-email-us" width="24" height="24"></ng-icon>
                </grid-col>
                <grid-col col="auto">
                    <div class="font-400 font-size-14px color-base-1300">
                        {{"forAssistance" | translate}}
                    </div>
                </grid-col>
            </grid-row>
        </a>
        <a href="mailto:{{item.email2}}" target="_blank" class="text-dec-none" *ngIf="item.email2 != ''" >
            <grid-row class="col-space-min align-item-center border-bottom border-color-2100 mt-30 pb-10">
                <grid-col col="auto">
                    <ng-icon iconClass="icon-email-us" width="24" height="24"></ng-icon>
                </grid-col>
                <grid-col col="auto">
                    <div class="font-400 font-size-14px color-base-1300">
                        {{"forAssistance" | translate}}
                    </div>
                </grid-col>
            </grid-row>
        </a>
    </div>
   
</modal>